'use client';

import { useCallback, useEffect, useState } from 'react';

interface UseIsScrolledProps {
  scrollPosition?: number;
}

export function useIsScrolled(props: UseIsScrolledProps = {}): boolean {
  const { scrollPosition = 1 } = props;

  const [isScrolled, setIsScrolled] = useState(false);

  const onScroll = useCallback(() => {
    if (window.scrollY >= scrollPosition) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  }, [scrollPosition]);

  useEffect(() => {
    if (window.scrollY >= scrollPosition) {
      setIsScrolled(true);
    }

    window.addEventListener('scroll', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll, scrollPosition]);

  return isScrolled;
}
